<template>
    <div class="add">
        <el-dialog
        title="Add Time"
        :visible.sync="addTimeDio"
        :modal-append-to-body="true"
        :show-close='false'
        class="editCardDio"
        @close="clsoeDio"
        id="timePicker"
        :close-on-click-modal='false'
        width="722px"
        center>
        <div>
            <div class="timePicker_box">
                <div @click.stop="showHourF=!showHourF,showHourT=false,showMinuteF=false,showMinuteT=false" class="time_selectBox">
                    {{hourF}}
                    <transition name="el-zoom-in-top">
                        <ul class="time_selectMsg_Box" id="top1" v-show="showHourF">
                            <li v-for="(item,i) in hourList" :key="i" @click="changeHourF(item)">
                                {{item}}
                            </li>
                        </ul>
                    </transition>
                </div>
                <div style="margin:0 20px;font-size: 18px;font-weight:600;color:#fff">:</div>
                <div @click.stop="showMinuteF=!showMinuteF,showHourT=false,showHourF=false,showMinuteT=false" class="time_selectBox">
                    {{minuteF}}
                    <transition name="el-zoom-in-top">
                        <ul class="time_selectMsg_Box" id="top2" v-show="showMinuteF">
                            <li v-for="(item,i) in openingMinutes" :key="i" @click="changeMinuteF(item)">
                                {{item}}
                            </li>
                        </ul>
                    </transition>
                </div>
                <div @click="aF='am'" style="margin:0 20px;font-size:16px;font-weight:600;color:#646a76;cursor:pointer" :class="{'check':aF=='am'}">am</div>
                <div @click="aF='pm'" style="font-size:16px;font-weight:600;color:#646a76;cursor:pointer" :class="{'check':aF=='pm'}">pm</div>

                <span class="time_picker_line"></span>

                <div @click.stop="showHourT=!showHourT,showHourF=false,showMinuteF=false,showMinuteT=false" class="time_selectBox">
                    {{hourT}}
                    <transition name="el-zoom-in-top">
                        <ul class="time_selectMsg_Box" id="top3" v-show="showHourT">
                            <li v-for="(item,i) in hourList" :key="i" @click="changeHourT(item)">
                                {{item}}
                            </li>
                        </ul>
                    </transition>
                </div>
                <div style="margin:0 20px;font-size: 18px;font-weight:600;color:#fff">:</div>
                <div @click.stop="showMinuteT=!showMinuteT,showHourF=false,showMinuteF=false,showHourT=false" class="time_selectBox">
                    {{minuteT}}
                    <transition name="el-zoom-in-top">
                        <ul class="time_selectMsg_Box" id="top4" v-show="showMinuteT">
                            <li v-for="(item,i) in minuteList" :key="i" @click="changeMinuteT(item)">
                                {{item}}
                            </li>
                        </ul>
                    </transition>
                </div>
                <div @click="tF='am'" style="margin:0 20px;font-size:16px;font-weight:600;color:#646a76;cursor:pointer" :class="{'check':tF=='am'}">am</div>
                <div @click="tF='pm'" style="font-size:16px;font-weight:600;color:#646a76;cursor:pointer" :class="{'check':tF=='pm'}">pm</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close" class="cardCanBtn">Cancel</el-button>
                <el-button @click="add" class="cardConBtn">Add</el-button>
            </span>
        </div>
        </el-dialog>
    </div>
    
</template>

<script>
export default {
    props: {
        show:{
            type: Number,
            default: () => {
                return 1;
            }
        },
        addTimeDio:{
            type: Boolean,
            default: () => {
                return false;
            }
        },
    },
    data() {
        return {
            showTwo:1,
            showHourF:false,
            showHourT:false,
            showMinuteF:false,
            showMinuteT:false,
            hourF:'',
            minuteF:'',
            aF:'am',
            tF:'am',
            hourT:'',
            minuteT:'',
            hourList:['01','02','03','04','05','06','07','08','09','10','11','12'],
            openingMinutes: ['00', '30'],
            minuteList:[]
        }
    },
    methods: {
        changeHourF(val){
            this.hourF=val
        },
        changeHourT(val){
            this.hourT=val
        },
        changeMinuteF(val){
            this.minuteF=val
        },
        changeMinuteT(val){
            this.minuteT=val
        },
        close(){
            this.$emit('cancel')
        },
        add(){
            if(!this.hourF||!this.minuteF||!this.hourT||!this.minuteT){
                this.$message.error('Please select time !')
                return
            }
            const start = `${this.aF=='am'?(this.hourF!=12?this.hourF:Number(this.hourF)-12):(this.hourF==12?this.hourF:Number(this.hourF)+12)}:${this.minuteF}`
            const end = `${this.tF=='am'?(this.hourT!=12?this.hourT:Number(this.hourT)-12):(this.hourT==12?this.hourT:Number(this.hourT)+12)}:${this.minuteT}`
            if(!Utils.timeToCompare(start,end,'end')){ // 结束时间大于开始时间
                this.$message.error('The end time cannot be less than the start time')
                return
            }
            let time=`${this.hourF}:${this.minuteF} ${this.aF} - ${this.hourT}:${this.minuteT} ${this.tF}`
            this.$emit('add',time)
            this.hourF=''
            this.hourT=''
            this.minuteF=''
            this.minuteT=''
            this.aF='am'
            this.tF='am'
        },
        clsoeDio(){ // 关闭弹框
            this.showHourF=false
            this.showHourT=false
            this.showMinuteF=false
            this.showMinuteT=false
            this.hourF=''
            this.hourT=''
            this.minuteF=''
            this.minuteT=''
            this.aF='am'
            this.tF='am'
        },
        dioClose(){
            this.showHourF=false
            this.showHourT=false
            this.showMinuteF=false
            this.showMinuteT=false
        }
    },
    mounted() {
        this.$nextTick(() => {
            document.getElementById('top1').scrollIntoView()
            document.getElementById('top2').scrollIntoView()
            document.getElementById('top3').scrollIntoView()
            document.getElementById('top4').scrollIntoView()
        })
        document.getElementById('timePicker').onclick=()=>{
            this.dioClose()
        }
        let key = 0
        while (key<60) {
            if(key<10){
                this.minuteList.push(`0${key}`)
            }else{
                this.minuteList.push(key)
            }
            key++;
        }
    },
    watch: {
        // hourF(n,o){
        //     if(n>=12){
        //         this.aF='pm'
        //     }else{
        //         this.aF='am'
        //     }
        // },
        // hourT(n,o){
        //     if(n>=12){
        //         this.tF='pm'
        //     }else{
        //         this.tF='am'
        //     }
        // },
    },
}
</script>

<style lang="scss">
    .timePicker_box{
        position: relative;
        z-index: 2020;
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        margin: 25px 0 50px 0;
        .time_selectBox{
            width: 50px;
            height: 40px;
            line-height: 40px;
            background: #2b3444;
            border: none;
            border-bottom: 2px solid #FFFFFF;
            text-align: center;
            color: #FFFFFF;
            font-size:16px;
            font-weight: 600;
            position: relative;
            .time_selectMsg_Box{
                position: absolute;
                width: 100%;
                top: 50px;
                max-height: 200px;
                overflow-y: auto;
                background:#161a22;
                border-radius: 3px;
                cursor: pointer;
                &::-webkit-scrollbar {
                    display: none; /* Chrome Safari */
                }
            }
        }
        .time_picker_line{
            width: 20px;
            height: 2px;
            background-color: #fff;
            margin: 0 60px;
        }
    }
    .check{
        color: #fff !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/timepicker.vue